import { useState } from "react";
import { router } from "@inertiajs/react";
import AppShell from "../../components/Shell/AppShell";
import { common, pick } from "../../lib/i18n";

interface Props {
  errors?: string[];
  products?: { id: number; name: string }[];
  current_user: { name: string; email: string; role: string };
  minimum_password_length: number;
}

const copy = {
  pl: { title: "Moje konto", passwordChange: "Zmiana hasła", currentPassword: "Obecne hasło", submit: "Zmień hasło" },
  en: { title: "My account", passwordChange: "Change password", currentPassword: "Current password", submit: "Change password" },
};

export default function AccountEdit({ errors = [], products = [], current_user, minimum_password_length }: Props) {
  const t = pick(copy);
  const c = common();
  const [form, setForm] = useState({ current_password: "", password: "", password_confirmation: "" });

  const initials = current_user.name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    router.put("/users", { user: form }, {
      onSuccess: () => setForm({ current_password: "", password: "", password_confirmation: "" }),
    });
  };

  return (
    <AppShell
      products={products}
      user={{ name: current_user.name, initials, role: current_user.role }}
    >
      <div className="page" style={{ maxWidth: 480 }}>
        <div className="page-hd">
          <div><h2>{t.title}</h2></div>
        </div>

        <div className="panel" style={{ marginBottom: 14 }}>
          <div className="panel-body">
            <div className="field">
              <label>{c.auth.email}</label>
              <input className="input" type="email" value={current_user.email} disabled />
            </div>
          </div>
        </div>

        <div className="panel">
          <div className="panel-hd"><h3>{t.passwordChange}</h3></div>
          <div className="panel-body">
            {errors.length > 0 && (
              <div style={{ marginBottom: 14, padding: "8px 12px", background: "oklch(0.62 0.20 25 / 0.08)", border: "1px solid oklch(0.62 0.20 25 / 0.3)", borderRadius: "var(--radius)", fontSize: 12, color: "var(--danger)" }}>
                {errors.map((e, i) => <div key={i}>{e}</div>)}
              </div>
            )}

            <form onSubmit={submit}>
              <div className="field">
                <label>{t.currentPassword}</label>
                <input
                  className="input"
                  type="password"
                  value={form.current_password}
                  onChange={(e) => setForm({ ...form, current_password: e.target.value })}
                  required
                  autoComplete="current-password"
                />
              </div>
              <div className="field">
                <label>{c.auth.newPassword}</label>
                <input
                  className="input"
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  minLength={minimum_password_length}
                  required
                  autoComplete="new-password"
                />
              </div>
              <div className="field" style={{ marginBottom: 18 }}>
                <label>{c.auth.confirmNewPassword}</label>
                <input
                  className="input"
                  type="password"
                  value={form.password_confirmation}
                  onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
                  minLength={minimum_password_length}
                  required
                  autoComplete="new-password"
                />
              </div>
              <button type="submit" className="btn btn-primary">{t.submit}</button>
            </form>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
